import { Component, OnInit, Inject, inject, DestroyRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { CapabilityType} from 'src/app/models/service/capability';
import { CapabilitiesService } from 'src/app/services/api/capabilities.service';
import {InstallationSpecificationService} from 'src/app/services/util/installation-specification.service';
import cloneDeep from 'lodash/cloneDeep';
import {FormUtilService} from 'src/app/services/util/form-util.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ToastrService } from 'src/app/services/util/toastr.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'app-secret',
    templateUrl: './secret.component.html',
    styleUrls: ['./secret.component.scss'],
    standalone: false
})
export class SecretComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  serviceTitle: any;
  serviceDefinition: any;
  blueprintTitle: any;
  environment: any;
  instanceName: any;
  capabilities: any;
  capabilityIncluded: any;
  capabilityOptional: any;
  currentStep = 0;
  stepsArray = [];
  highestStep = -1;
  headerData: any;
  topHeader: any;
  noPrevious: any;
  capabilityName: any;
  capabilityVersion: any;
  installationSpecificationForms: any;
  dataLoading = true;
  instanceId: any;
  secretAvailableKey: any;
  secretKeyData: any;
  displayName = false;
  submitEnable = false;
  isValid = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public matdialogRef: MatDialogRef<SecretComponent>,
     private installationSpecificationService: InstallationSpecificationService,
     private capabilitiesService: CapabilitiesService,
     private matDialog: MatDialog,
      private instancesService: InstancesService, private toastrService: ToastrService) {
      this.serviceTitle = data.serviceName;
      this.serviceDefinition = data.serviceDefinition;
      this.blueprintTitle = data.blueprintName;
      this.environment = data.environment;
      this.instanceName = data.instanceName;
      this.instanceId = data.instanceId;
      this.capabilities = data.capabilities;
    }

  ngOnInit(): void {
    this.headerData = this.capabilities[0]?.displayName;
    this.capabilityName = this.capabilities[0]?.name;
    this.capabilityVersion = this.capabilities[0]?.version;
    this.topHeader = translate('CAPABILITIES.INCLUDED_CAPABILITIES');
    this.capabilityIncluded = [];
    this.capabilityOptional = [];
    let step = 0;
    for(const capability of this.capabilities) {
      capability.value = '';
    }
    this.instancesService.getSecrets(this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response =>  {
        if(response) {
          this.secretAvailableKey = response;
          for (const data of this.secretAvailableKey) {
            for (const capabilityName of this.capabilities) {
              if(data.capability === capabilityName.name) {
                this.capabilities[capabilityName.step].secrets = data.secrets;
                this.viewDetails(this.capabilityName, this.capabilityVersion, this.headerData);
              }
          }
          }
        }
      },
      (error) => {
        this.dataLoading = false;
        this.matdialogRef.close(true);
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.SECRET_NOT_AVAILABLE'),
            description: error?.error?.message,
          }
        });
      });
    for (const capability of this.capabilities) {
      if (capability.required !== CapabilityType.OPTIONAL) {
        capability.step = step;
        capability.validated = false;
        this.capabilityIncluded.push(capability);
        step = step + 1;
      } else if(capability.required === CapabilityType.OPTIONAL) {
        capability.step = step;
        capability.validated = false;
        this.capabilityOptional.push(capability);
        step = step + 1;
      }
    }
  }

  async viewDetails(capabilityName, capabilityVersion, displayName?): Promise<void> {
    this.displayName = false;
    if(displayName || capabilityName) {
      this.displayName = true;
      this.dataLoading = true;
      (await this.capabilitiesService.getCapabilitiesView({ name: capabilityName, version: capabilityVersion }))
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data =>  {
        if(data.secretSpec) {
        this.secretKeyData = true;
        this.submitEnable = true;
        const data1 = atob(data.secretSpec);
        const data2 = JSON.parse(data1);
        const require = cloneDeep(data2.components?.schemas?.rootinstall);

        const required = cloneDeep(['secret']);
        data2.components.schemas.rootinstall = {};
        data2.components.schemas.rootinstall.required = cloneDeep(required);
        data2.components.schemas.rootinstall.type = cloneDeep('object');
        data2.components.schemas.secret = cloneDeep(require);
        data2.components.schemas.rootinstall.properties = {
          secret: {
            $ref: '#/components/schemas/secret'
          }
        };
        data2.components.schemas.secret.required = cloneDeep(require.required);
        this.installationSpecificationForms = this.installationSpecificationService.buildSecretDynamicForms(
          data2
        );
        if (this.capabilities[this.currentStep].value) {
          const keys = Object.keys(this.capabilities[this.currentStep].value);
          keys.forEach(key => {
            this.installationSpecificationForms[0].property.properties.find(item => item.name === key).secretField = true;
            this.installationSpecificationForms[0].property.properties.find(item => item.name === key).default =
              this.capabilities[this.currentStep].value[key];
          });
        }

        if (!this.capabilities[this.currentStep].value && this.capabilities[this.currentStep].secrets) {
          const properties = this.installationSpecificationForms[0].property.properties;
          const secretFields = this.capabilities[this.currentStep].secrets;
          properties.forEach(item => {
            if (secretFields.find(field => field.name === item.name)) {
              this.installationSpecificationForms[0].property.properties.find(property => property.name === item.name).secretField = true;
            }
            if (secretFields.find(field => field.name === item.name) &&
              secretFields.find(field => field.name === item.name)?.available === 'true') {
              this.installationSpecificationForms[0].property.properties.find(property => property.name === item.name).default = '********';
            } else {
              this.installationSpecificationForms[0].property.properties.find(property => property.name === item.name).default = '';
            }
          });
        }
        this.dataLoading = false;
        } else {
          this.dataLoading = false;
          this.secretKeyData = false;
        }
      });
    }
  }


  onClick(dataName?, capability?): void {
  if(this.displayName) {
    if((this.capabilities.length - 1) === this.currentStep) {
      if(FormUtilService.validateForm(this.installationSpecificationForms[0].formGroup.controls.secret)) {
        this.capabilities[this.currentStep].validated = true;
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    }
    if(this.secretKeyData && this.capabilities[dataName.step].validated === true) {
      this.currentStep = dataName.step;
      this.topHeader = translate(capability);
      this.headerData = dataName?.displayName;
      this.capabilityName = dataName?.name;
      this.capabilityVersion = dataName?.version;
      this.viewDetails(this.capabilityName, this.capabilityVersion, this.headerData);
    }
    if(this.secretKeyData && !FormUtilService.validateForm(this.installationSpecificationForms[0].formGroup.controls.secret)) {
      if(dataName.step !== this.currentStep) {
        this.toastMandatory();
      }
      return;
    }
    if(this.secretKeyData) {
      this.capabilities[this.currentStep].value = this.installationSpecificationForms[0].formGroup.controls.secret.getRawValue();
    }
    this.capabilities[this.currentStep].validated = true;
    let flag = true;
    for(let i=0; i<dataName.step; i++) {
      if(this.capabilities[i].validated !== true) {
        flag = false;
      }
    }
    if(this.capabilities[dataName.step].validated === true || (dataName.step === this.currentStep + 1) || flag) {
      this.currentStep = dataName.step;
      this.topHeader = translate(capability);
      this.headerData = dataName?.displayName;
      this.capabilityName = dataName?.name;
      this.capabilityVersion = dataName?.version;
      this.viewDetails(this.capabilityName, this.capabilityVersion, this.headerData);
    }
   }
  }

  goToPrevious(): void {
    this.selfHeader(this.currentStep - 1);
    if(this.currentStep === 0) {
      this.headerData = this.capabilities[this.currentStep]?.displayName;
      this.noPrevious = false;
      return;
    }else {
      if((this.capabilities.length - 1) === this.currentStep) {
        if(FormUtilService.validateForm(this.installationSpecificationForms[0].formGroup.controls.secret)) {
          this.capabilities[this.currentStep].validated = true;
        }
      }
      this.currentStep = this.currentStep - 1;
      this.headerData = this.capabilities[this.currentStep]?.displayName;
      this.capabilityName = this.capabilities[this.currentStep]?.name;
      this.capabilityVersion = this.capabilities[this.currentStep]?.version;
      this.capabilities[this.currentStep + 1].value = this.installationSpecificationForms[0].formGroup.controls.secret.getRawValue();
      this.viewDetails(this.capabilityName, this.capabilityVersion, this.headerData);

    }
  }

  goToNext(): void {
    if(this.displayName) {
      if(this.secretKeyData && !FormUtilService.validateForm(this.installationSpecificationForms[0].formGroup.controls.secret)) {
        this.toastMandatory();
        return;
      }
      this.capabilities[this.currentStep].validated = true;
      this.selfHeader(this.currentStep + 1);
      this.currentStep = this.currentStep + 1;
      this.headerData = this.capabilities[this.currentStep]?.displayName;
      this.capabilityName = this.capabilities[this.currentStep]?.name;
      this.capabilityVersion = this.capabilities[this.currentStep]?.version;
      if(this.secretKeyData) {
      this.capabilities[this.currentStep - 1].value = this.installationSpecificationForms[0].formGroup.controls.secret.getRawValue();
      }
      this.viewDetails(this.capabilityName, this.capabilityVersion, this.headerData);
    }
  }

  selfHeader(step): void {
    if (this.capabilities[step].required !== CapabilityType.OPTIONAL) {
      this.topHeader = translate('CAPABILITIES.INCLUDED_CAPABILITIES');
  } else {
    this.topHeader = translate('CAPABILITIES.OPTIONAL_CAPABILITIES');
  }
  }

  toastMandatory(): void {
    this.toastrService.clear();
      setTimeout(() => {
        this.toastrService.checkboxMessage(
          `${'Please enter all mandatory fields'}`
          );
      }, 500);
  }

  submit(): void {
    if(!FormUtilService.validateForm(this.installationSpecificationForms[0].formGroup.controls.secret)) {
      this.toastMandatory();
      return;
    }
    this.capabilities[this.currentStep].validated = true;
    this.capabilities[this.currentStep].value = this.installationSpecificationForms[0].formGroup.controls.secret.getRawValue();
    const secrets = [];
    this.capabilities.forEach(capability => {
      const values = capability.value;
      const keys = Object.keys(capability.value);
      keys.forEach(key => {
        if (!values[key] || values[key] === '********') {
          delete values[key];
        }
      });
      if(Object.keys(values).length > 0) {
        const data1 = {
          capability: capability.name,
          secretDoc: values
        };
        secrets.push(data1);
      }
    });
    this.instancesService.applySecrets(secrets, this.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data =>  {
        if(data) {
          for(const capability of this.capabilities) {
            capability.value = '';
          }
          this.toastrService.clear();
            setTimeout(() => {
              this.toastrService.checkboxMessage(
                `${'Secrets Updated Successfully'}`
                );
            }, 500);
          this.matdialogRef.close(true);
        }
      },
      (error) => {
        this.matDialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog',
          data: {
            title:  translate('NOTIFICATIONS.UPDATE_SECRETS_FAILED'),
            description: error,
          }
        });
      });
  }
}
